module.exports = __webpack_public_path__ + "static/media/17.skype.de1a65dc.svg";